import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { ColorSAP } from "../../ontego-ui";
import { arrowGenerator } from "./ArrowGenerator";

const color = ColorSAP.primary[80];

const Styled = {};

Styled.Arrow = styled("span")({
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: 0,
    height: 0,
    borderStyle: "solid",
  },

  // Placement-specific styles
  '[data-popper-placement*="bottom"] &': {
    top: 0,
    left: 0,
    marginTop: "-0.95em",
    width: "2em",
    height: "1em",
    "&::before": {
      borderWidth: "0 1em 1em 1em",
      borderColor: `transparent transparent ${color} transparent`,
    },
  },
  '[data-popper-placement*="top"] &': {
    bottom: 0,
    left: 0,
    marginBottom: "-0.95em",
    width: "2em",
    height: "1em",
    "&::before": {
      borderWidth: "1em 1em 0 1em",
      borderColor: `${color} transparent transparent transparent`,
    },
  },
  '[data-popper-placement*="right"] &': {
    left: 0,
    marginLeft: "-0.95em",
    height: "2em",
    width: "1em",
    "&::before": {
      borderWidth: "1em 1em 1em 0",
      borderColor: `transparent ${color} transparent transparent`,
    },
  },
  '[data-popper-placement*="left"] &': {
    right: 0,
    marginRight: "-0.95em",
    height: "2em",
    width: "1em",
    "&::before": {
      borderWidth: "1em 0 1em 1em",
      borderColor: `transparent transparent transparent ${color}`,
    },
  },
});

Styled.Tooltip = styled(Box)({
  position: "relative",
  borderRadius: 4,
  padding: "8px 24px",
  backgroundColor: ColorSAP.primary[80],
  color: ColorSAP.neutral[0],

  '[data-popper-placement*="left"] &': {
    margin: '0 8px',
  },
  '[data-popper-placement*="right"] &': {
    margin: '0 8px',
  },
  '[data-popper-placement*="top"] &': {
    margin: '8px 0',
  },
  '[data-popper-placement*="bottom"] &': {
    margin: '8px 0',
  },
});

export default Styled;
